import Container from '@mui/material/Container'
import { styled } from '@mui/material/styles'
import ApplicationTable from 'components/applications/ApplicationTable'
import type { NextPage } from 'next'
import Head from 'next/head'

const Home: NextPage = () => {
  return (
    <Container>
      <Head>
        <title>Applications | Publisher Dashboard</title>
        <meta name="description" content="Offerwall Publisher Dashboard" />
        <meta name="viewport" content="initial-scale=1, width=device-width" />
        <link rel="icon" href="/favicon.svg" type="images/svg" />
      </Head>

      <Main>
        <ApplicationTable />
      </Main>
    </Container>
  )
}

const Main = styled('main')`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 24px;
`

export default Home
